//属性数据
export const attribute = {
  account: [
    { label: "授权状态", value: "status" },
    { label: "最后更新时间", value: "createTime" },
    { label: "优化师", value: "optimizer" },
    { label: "剩余账号预算", value: "balance" },
    { label: "预算金额", value: "dailyBudget" },
  ],
  adSeries: [
    { label: "广告账户ID", value: "advertiserId" },
    { label: "广告账户名称", value: "advertiserName" },
    { label: "预算", value: "dailyBudget" },
    { label: "日预算消耗", value: "costPerBudget" },
    { label: "出价", value: "cpa" },
    { label: "广告系列类型", value: "campaignType" },
    { label: "状态", value: "status" },
    { label: "产品", value: "appName" },
  ],
  adGroup: [
    { label: "广告账户名称", value: "advertiserName" },
    { label: "广告账户ID", value: "advertiserId" },
    { label: "广告系列名称", value: "campaignName" },
    { label: "广告系列ID", value: "campaignId" },
    { label: "产品", value: "appName" },
    { label: "状态", value: "status" },
  ],
  materialResources: [
    { label: "广告账户名称", value: "advertiserName" },
    { label: "广告账户ID", value: "advertiserId" },
    { label: "素材类型", value: "assetType" },
    { label: "所属广告组", value: "adGroupAssetList" },
  ],
};

//基础数据
export const baseData = [
  { label: "花费", value: "cost" },
  { label: "展示数", value: "showCnt" },
  { label: "点击数", value: "clickCnt" },
  { label: "点击率", value: "ctr" },
  { label: "点击成本", value: "cpc" },
  { label: "千次展示成本", value: "thousandDisplayPrice" },
];
const basicAppData = [
  { label: "转化数", value: "convertCnt" },
  { label: "转化成本", value: "convertCntCost" },
  { label: "转化率", value: "convertCntRate" },
  // { label: "激活数", value: "activeCnt" },
  // { label: "激活成本", value: "activeCost" },
  // { label: "激活率", value: "activeRate" },
  { label: "互动转化率", value: "engagementConvertRate" },
  // { label: "深度转化数", value: "deepConvert" },
  { label: "转化价值", value: "convertValue" },
  { label: "转化价值/费用", value: "convertValuePerCost" },
  { label: "所有转化次数", value: "allConvertCnt" },
  { label: "每次转化价值", value: "perConvertValue" },
  { label: "费用/所有转化次数", value: "costPerConvert" },
  { label: "所有转化率", value: "allConvertRate" },
  { label: "所有转化价值", value: "allConvertValue" },
  { label: "所有转化价值/费用", value: "allConvertValuePerCost" },
  { label: "价值/所有转化次数", value: "costPerAllConvert" },
];
//应用数据
export const appData = {
  account: basicAppData,
  adSeries: basicAppData.concat([
    { label: "互动次数", value: "engagement" },
    { label: "互动率", value: "engagementRate" },
  ]),
  adGroup: basicAppData.concat([
    { label: "互动次数", value: "engagement" },
    { label: "互动率", value: "engagementRate" },
  ]),
  materialResources: [
    { label: "转化数", value: "convertCnt" },
    { label: "转化成本", value: "convertCntCost" },
    { label: "转化率", value: "convertCntRate" },
    { label: "转化价值", value: "convertValue" },
    { label: "转化价值/费用", value: "convertValuePerCost" },
    { label: "所有转化次数", value: "allConvertCnt" },
    { label: "每次转化价值", value: "perConvertValue" },
    { label: "费用/所有转化次数", value: "costPerConvert" },
    { label: "所有转化率", value: "allConvertRate" },
    { label: "所有转化价值", value: "allConvertValue" },
    { label: "所有转化价值/费用", value: "allConvertValuePerCost" },
    { label: "价值/所有转化次数", value: "costPerAllConvert" },
    { label: "安装次数", value: "installCount" },
    { label: "应用内操作次数", value: "appConvert" },
    { label: "每次安装费用", value: "installCost" },
    { label: "每次应用内操作费用", value: "appConvertCost" },
  ],
};

// 转化价值
export const transformEventData = [
  { label: "安装次数", value: "installCount" },
  { label: "安装成本", value: "installCost" },
  { label: "应用内操作次数", value: "appConvert" },
  { label: "应用内操作费用", value: "appConvertCost" },
  { label: "下载次数", value: "downloadCount" },
  { label: "下载成本", value: "downloadCost" },
];

/* 素材类型字段枚举 */
export const assetTypesList = [
  { label: "视频", value: "YOUTUBE_VIDEO" },
  { label: "图片", value: "IMAGE" },
  { label: "文案", value: "TEXT" },
];

/* 素材审核字段枚举 */
export const reviewStatusOptions = [
  { label: "审核中", value: "UNSPECIFIED" },
  { label: "审核通过", value: "APPROVED" },
  { label: "已审核（受限）", value: "APPROVED_LIMITED" },
  { label: "已拒登", value: "DISAPPROVED" },
  { label: "未指定", value: "UNKNOWN" },
];

/* 素材表现字段枚举 */
export const performancesList = [
  { label: "BEST", value: "BEST" },
  { label: "GOOD", value: "GOOD" },
  { label: "LOW", value: "LOW" },
  { label: "LEARNING", value: "LEARNING" },
  { label: "PENDING", value: "PENDING" },
  { label: "UNKNOWN", value: "UNKNOWN" },
  { label: "UNSPECIFIED", value: "UNSPECIFIED" },
];

/* Google广告系列，广告组状态字段枚举 */
export const adSeriesStatusOptions = [
  { value: "UNSPECIFIED", label: "未指定" },
  { value: "UNKNOWN", label: "未知" },
  { value: "ENABLED", label: "已启用" },
  { value: "PAUSED", label: "已暂停" },
  { value: "REMOVED", label: "已删除" },
];
